var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "verification-method-modal",
      attrs: {
        id: "accountVerification-verificationMethod",
        visible: _vm.dialogVisibility,
        width: "650px",
        "show-close": true,
        title: "Cancel Authorization",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisibility = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "steps-container" },
        [
          _c("warning-step", {
            attrs: {
              title: "Cancel this user’s account authorization?",
              description:
                "If you do this, you’ll need to verify their account again.",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "account-verification__step__buttons-container" },
            [
              _c(
                "el-button",
                {
                  staticClass:
                    "account-verification__step__button account-verification__step__button-white",
                  attrs: { plain: "", type: "primary" },
                  on: { click: _vm.exitFlow },
                },
                [_vm._v("\n        Back\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "account-verification__step__button",
                  attrs: { type: "primary" },
                  on: { click: _vm.cancelPendingAuthorization },
                },
                [_vm._v("\n        Cancel Authorization\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }